import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuDropdown, MenuItem } from '@features/events/common';
import { ArrowDown } from '@shared/assets';
import { useCommonMenu } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import { allTypes } from '../../model';
import * as st from './styles.module.scss';

export const Type = (): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const types = allTypes;

  const { onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useCommonMenu();

  const errorMessage = getErrorMessages(errors, ['language']).join(' ');

  return (
    <fieldset>
      <Controller
        control={control}
        name="event_type"
        render={({ field: { value, onChange, onBlur } }) => (
          <div className={st.language}>
            <div
              className={cn(st.language__field, !!errors.language && st.language__error)}
              onClick={onOpen}
              ref={setReferenceEl}
            >
              <span>{value || ''}</span>
              <div className={st.icon}>
                <ArrowDown />
              </div>
            </div>
            <MenuDropdown popperEl={popperEl} referenceEl={referenceEl} setPopperEl={setPopperEl}>
              {types.map((type) => (
                <MenuItem
                  key={type.id}
                  onClick={(e) => {
                    onClose(e);
                    onChange(type.title);
                  }}
                  onBlur={onBlur}
                  className={st.language__item}
                >
                  {type.title}
                </MenuItem>
              ))}
            </MenuDropdown>
          </div>
        )}
      />
    </fieldset>
  );
};
